var map = {
	"./app.js": "4396",
	"./errorLog.js": "4ee9",
	"./page.js": "c28e",
	"./permission.js": "774f",
	"./settings.js": "3c33",
	"./tagsView.js": "cf67",
	"./user.js": "be1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d290";